import { CommonModule, formatDate } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { DialogService } from 'primeng/dynamicdialog';
import { FloatLabel } from 'primeng/floatlabel';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { PanelModule } from 'primeng/panel';
import { ProgressBarModule } from 'primeng/progressbar';
import { firstValueFrom, forkJoin, Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { environment } from '../../environments/environment';
import { Palettes } from '../../themes/palette';
import { IntlTelInputComponent } from "../components/intl-tel-input/intl-tel-input.component";
import { Api100Service } from '../service/api100.service';
import { DialogServiceCustom } from '../service/dialog.service';
import { GtagService } from '../service/gtag.service';
import { PhoneValidService } from '../service/phone-valid.service';
import { SpinnerService } from '../service/spinner.service';
import { SuitecrmService } from '../service/suitecrm.service';
import { ConfigService } from '../service/config.service';
import { Api400SigelService } from '../service/api400-sigel.service';

//http://localhost:5200/?campania=2&rs=fb&sociedad=1800&nom_c=Titulo%20Campa%C3%B1a%20Test&desc=Aqu%C3%AD%20ir%C3%A1%20la%20descripci%C3%B3n%20de%20la%20campa%C3%B1a.%20Este%20texto%20puede%20cambiar%20din%C3%A1micamente%20seg%C3%BAn%20los%20par%C3%A1metros

@Component({
	selector: 'app-formulario',
	imports: [
		ReactiveFormsModule,
		FormsModule,
		PanelModule,
		DropdownModule,
		ProgressBarModule,
		CardModule,
		AutoCompleteModule,
		InputTextModule,
		ButtonModule,
		FloatLabel,
		IconField,
		InputIcon,
		IntlTelInputComponent,
		DialogModule,
		CommonModule
	],
	templateUrl: './formulario.component.html',
	styleUrl: './formulario.component.scss',
	providers: [SpinnerService, DialogService]
})
export class FormularioComponent implements OnInit, OnDestroy, AfterViewInit {
	public formGroup: FormGroup;

	public countriesCodes: any[] = [];
	public filteredCountriesCodes: any[] = [];
	public countries: any[] = [];
	public filteredCountries: any[] = [];
	public cities: any[] = [];
	public filteredCities: any[] = [];
	public empresaConfig: any;
	public data: any;
	private formBuilder: FormBuilder;
	public selectCountryCode: any;
	public selectCountry: any;
	public labelBoton: string;
	public sociedad!: number;
	private subscription!: Subscription;

	// Parámetros de URL
	public campania: string | null = null;
	public nom_c: string | null = null;
	public desc: string | null = null;
	public rs: string | null = null;

	//simulator variables
	CONSTANTS: any;
	superficies: any = [];
	categorias: any = [];
	selectSuperficie: any;
	loading: Boolean = false;
	precio_contado: any = "";
	cuota_inicial_minima: any = "";
	cuota_mes_desde: any = "";
	header: string = 'COTIZA AQUI';
	disableOption: boolean = true;
	public buttonColors: { [key: number]: string } = {
		1200: '#0da548', // Techo (Rojo)
		1300: '#0da548', // El Pahuichi (Verde)
		1600: '#0da548', // Monumental (Naranja)
		1700: '#0da548', // Pilat (Azul oscuro)
		1800: '#0da548', // Nueva Santa Cruz (Turquesa)
		2400: '#0da548', // CasaMia (Azul claro)
	};
	public buttonColor!: string;
	@ViewChild(IntlTelInputComponent) phoneInputComponent!: IntlTelInputComponent;
	private selectedPalette: any;
	private secondaryColor: any;
	logo = '';

	// Datos de campaña (API400 Sigel)
	paginasCampania: any[] = [];
	paginaCampania: any = null;

	// Propiedades visuales dinámicas (pueden venir de URL params o de API400)
	bgImage: string = '';
	logoUrl: string = '';
	recursoUrl: string = '';
	desc2: string | null = null;

	// Estilos dinámicos desde json_css de la API400 (solo si llega json_css)
	logoStyles: { [key: string]: string } = {};
	tituloStyles: { [key: string]: string } = {};
	subTituloStyles: { [key: string]: string } = {};
	subTitulo2Styles: { [key: string]: string } = {};
	recursoImagenStyles: { [key: string]: string } = {};
	wrapperStyles: { [key: string]: string } = {};
	backdropStyles: { [key: string]: string } = {};

	constructor(
		private _serv: SuitecrmService,
		private titleService: Title,
		private route: ActivatedRoute,
		private dialogService: DialogServiceCustom,
		private gtagService: GtagService,
		private api100: Api100Service,
		private phoneValid: PhoneValidService,
		private spinnerService: SpinnerService,
		private configService: ConfigService,
		private api400: Api400SigelService
	) {
		this.sociedad = this.configService.getSociedadActiva();
		this.configService.setFavicon(this.sociedad);
		this.buttonColor = this.buttonColors[this.sociedad] || '#004585';
		this.selectedPalette = Palettes[this.sociedad as keyof typeof Palettes];
		this.secondaryColor = this.selectedPalette?.semantic?.secondary?.[900];
		this.empresaConfig = this.getEmpresa();
		this.logo = this.empresaConfig.titulo;
		this.formBuilder = new FormBuilder();
		this.formGroup = this.formBuilder.group({
			nombres: new FormControl({ value: '', disabled: false }, Validators.required),
			ap_pat: new FormControl({ value: '', disabled: false }, [Validators.required]),
			ap_mat: new FormControl({ value: '', disabled: false }, []),
			codigo: new FormControl({ value: '', disabled: false }, Validators.required),
			phone: new FormControl({ value: '', disabled: false }, Validators.required),
			email: new FormControl({ value: '', disabled: false }, [Validators.email]),
			pais: new FormControl({ value: '', disabled: false }, [Validators.required]),
			ciudad: new FormControl({ value: '', disabled: true }, [Validators.required]),
		});
		this.data = {
			type: 'Leads',
			attributes: {
				name: '',
				account_name: '',
				first_name: '',
				last_name: '',
				last_name2_c: '',
				email1: '',
				phone_mobile: '',
				phone_mobile_iso_c: 'BO',
				fecha_validez_c: '',
				tipo_prospecto_c: 'NORMAL',
				etapa_c: 'CAPTADO',
				lead_source: 'LANDING_PAGE',
				lead_source2_c: 'FACEBOOK',
				lead_source_description: '',
				primary_address_country: 'BO',
				primary_address_state: '00',
				assigned_user_id: '',
				created_by: '',
			},
		};
		// this.formGroup.controls['pais'].setValue(this.data.attributes.primary_address_country);
		this.formGroup.controls['phone'].setValue({ phoneNumber: '', dialCode: '591', countryCode: 'BO' });
		this.labelBoton = 'CONTACTO WHATSAPP';

		// Captura de parámetros desde la URL (?campania=99 o ?nom_c=...&desc=...)
		this.campania = this.route.snapshot.queryParamMap.get('campania');
		this.nom_c = this.route.snapshot.queryParamMap.get('nom_c');
		this.desc = this.route.snapshot.queryParamMap.get('desc');
		this.rs = this.route.snapshot.queryParamMap.get('rs'); //FACEBOOK, INSTAGRAM, TIKTOK, WHATSAPP (fb,ig,tt,ws)

		console.log('Parámetros recibidos:', {
			campania: this.campania,
			nom_c: this.nom_c,
			desc: this.desc,
			red_social: this.rs,
		});
	}

	ngAfterViewInit(): void {
		console.log('in after view init');
		setTimeout(() => {
			console.log('in after view init after 3 seconds');
			this.phoneInputComponent.writeValue({ phoneNumber: '', dialCode: '591', countryCode: 'BO' });
			this.formGroup.controls['phone'].setValue({ phoneNumber: '', dialCode: '591', countryCode: 'BO' });
		}, 3000);
	}

	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	async capturePHPSessionId() {
		const cookies = document.cookie;
		const sessionId = cookies
			.split('; ')
			.find(row => row.startsWith('PHPSESSID='))
			?.split('=')[1];
		console.log('ID de sesión de PHP:', sessionId);
	}

	ngOnInit(): void {
		this.spinnerService.show();

		//Escuchamos los cambios en el campo del Apellido Paterno (Separar apellidos juntos del autorrellenado del navegador!!!)
		let previousPatLength = 0;
		this.formGroup.get('ap_pat')?.valueChanges.subscribe(value => {
			if (value && typeof value === 'string') {
				const currentLength = value.length;
				// Si la diferencia de longitud es mayor a 2, asumimos que fue pegado/autorrellenado y no escrito a mano
				const isAutofill = (currentLength - previousPatLength) > 2;

				if (isAutofill) {
					// Limpiamos espacios extra
					const cleanValue = value.trim();

					// Si el valor contiene un espacio
					if (cleanValue.includes(' ')) {
						const parts = cleanValue.split(' ');

						// Si hay al menos dos partes y el apellido materno está vacío
						if (parts.length >= 2 && !this.formGroup.get('ap_mat')?.value) {
							const materno = parts.pop(); // Extraemos la última palabra
							const paterno = parts.join(' '); // Nos quedamos con el resto

							// Actualizamos los controles
							this.formGroup.get('ap_pat')?.setValue(paterno, { emitEvent: false });
							this.formGroup.get('ap_mat')?.setValue(materno, { emitEvent: false });

							previousPatLength = paterno.length;
							return;
						}
					}
				}
				previousPatLength = currentLength;
			} else {
				previousPatLength = 0;
			}
		});

		this.subscription = this.phoneValid.phoneDetails$.subscribe((phoneDetails) => {
			this.formGroup.controls['codigo'].setValue(phoneDetails.dialCode);
			this.formGroup.controls['phone'].setValue(phoneDetails);
		});
		this.data.attributes.lead_source2_c = this.data.attributes.lead_source2_c.toUpperCase();
		this.titleService.setTitle(this.empresaConfig.titulo + ' | Campaña');

		// Valores visuales por defecto (assets locales + parámetros de URL)
		this.bgImage = `url(/assets/bg/${this.sociedad}.jpg)`;
		this.logoUrl = `/assets/${this.logo}.png`;

		let a = this._serv.obtenerDiasVigencia();
		let b = this._serv.listarPaises();
		let c = this._serv.listarCodigos();
		forkJoin([a, b, c]).subscribe({
			next: (res) => {
				let dt = new Date();
				dt.setDate(dt.getDate() + res[0]);
				this.data.attributes.fecha_validez_c = formatDate(
					dt,
					'yyyy-MM-dd',
					'en-GB'
				);
				this.countries = res[1];
				this.countriesCodes = res[2];
				this.selectCountry = this.countries.find(
					(elem) =>
						elem.abr_pais == this.data.attributes.primary_address_country
				);
				this.selectCountryCode = this.countriesCodes.find(
					(elem) =>
						elem.iso2 == this.data.attributes.phone_mobile_iso_c.toLowerCase()
				);
				if (this.selectCountry) {
					this.formGroup.controls['pais'].setValue(this.selectCountry);
					this.cities = this.selectCountry.estados;
					this.formGroup.controls['ciudad'].enable();
				}
			},
			error: () => {
				Swal.fire({
					width: '300px',
					title: 'ERROR',
					text: 'Problemas con el servicio. Intentelo mas tarde.',
					allowOutsideClick: false,
					confirmButtonColor: this.secondaryColor,
					confirmButtonText: 'Aceptar',
				}).then(() => {
					window.location.reload();
				});
			},
		});

		// ForkJoin independiente para (API400 - Sigel)
		// Solo se ejecuta si el parámetro ?campania= fue enviado en la URL
		if (this.campania) {
			let d = this.api400.getPaginaCampaniaById(this.campania);
			forkJoin([d]).subscribe({
				next: (res) => {
					this.paginaCampania = res[0];
					console.log(`Página campaña ID=${this.campania}:`, this.paginaCampania);
					// Aplica los datos visuales provenientes de la API400
					this.aplicarDatosCampaniaApi(this.paginaCampania);
				},
				error: (err) => {
					console.error('Error al cargar datos de campaña API400:', err);
				},
			});
		}

		this.spinnerService.hide();
	}


	safeEncodeFileName(fileName: string): string {
		if (!fileName) return '';
		try {
			return encodeURIComponent(decodeURIComponent(fileName));
		} catch (e) {
			return encodeURIComponent(fileName);
		}
	}

	/**
	 * Aplica los datos visuales provenientes de la respuesta de la API400 Sigel.
	 * Solo se llama cuando el parámetro ?campania= está presente en la URL.
	 *
	 * Respuesta esperada: { id_pagina_campania, titulo, descripcion_1, url_img_logo,
	 *                       url_img_bg_mobile, url_img_bg_pc, json_css, sociedad, ... }
	 */
	private aplicarDatosCampaniaApi(data: any): void {
		if (!data) return;

		// Base de medios: quitamos "api/" del final de la ruta del environment
		const baseMedia = environment.api400.ruta.replace(/api\/$/, '');

		// ── Título de la campaña ─────────────────────────────────────────────
		if (data.titulo) {
			this.nom_c = data.titulo;
		}

		// ── Descripción 1 de la campaña ────────────────────────────────────────
		if (data.descripcion_1) {
			this.desc = data.descripcion_1;
		}

		// ── Descripción 2 de la campaña (opcional) ────────────────────────────
		if (data.descripcion_2) {
			this.desc2 = data.descripcion_2;
		}

		// ── Logo ─────────────────────────────────────────────────────────────
		if (data.url_img_logo) {
			this.logoUrl = `${baseMedia}mod_comercial/logo_campania/${this.safeEncodeFileName(data.url_img_logo)}`;
		}

		// ── Background image ─────────────────────────────────────────────────
		// Detecta si es pantalla estrecha para elegir mobile o pc
		const isMobile = window.innerWidth < 768;
		const bgFilename = isMobile ? (data.url_img_bg_mobile ?? data.url_img_bg_pc) : (data.url_img_bg_pc ?? data.url_img_bg_mobile);
		if (bgFilename) {
			const bgUrl = `${baseMedia}mod_comercial/fondo_campania/${this.safeEncodeFileName(bgFilename)}`;
			this.bgImage = `url('${bgUrl}')`;
		}

		// ── IMAGEN DE APOYO ────────────────────────────────────────────────────
		if (data.url_img_recurso) {
			this.recursoUrl = `${baseMedia}mod_comercial/recurso_campania/${this.safeEncodeFileName(data.url_img_recurso)}`;
		}

		// ── JSON CSS: sobrecarga de estilos visuales ─────────────────────────────────
		if (data.json_css) {
			const css = data.json_css;
			// Detecta breakpoint actual: xs < 576, md < 768, lg >= 768
			const w = window.innerWidth;
			const bp: 'xs' | 'md' | 'lg' = w < 576 ? 'xs' : w < 768 ? 'md' : 'lg';

			// • Background (landing-wrapper)
			if (css.background) {
				if (css.background['background-position']) {
					this.wrapperStyles['background-position'] = css.background['background-position'];
				}
				if (css.background['backdrop-opacity']) {
					this.backdropStyles['background-color'] = `rgba(0, 0, 0, ${css.background['backdrop-opacity']})`;
				}
			}

			// • Logo
			if (css.logo) {
				if (css.logo.background_active && css.logo.background_color) {
					this.logoStyles['background-color'] = css.logo.background_color;
				} else if (!css.logo.background_active) {
					this.logoStyles['background-color'] = 'transparent';
					this.logoStyles['padding'] = '0';
				}
				if (css.logo.border_radius) this.logoStyles['border-radius'] = css.logo.border_radius;
			}

			// • Título
			if (css.titulo) {
				if (css.titulo.font_size?.[bp]) this.tituloStyles['font-size'] = css.titulo.font_size[bp];
				if (css.titulo.line_height) this.tituloStyles['line-height'] = css.titulo.line_height;
				if (css.titulo.font_weight) this.tituloStyles['font-weight'] = css.titulo.font_weight;
				if (css.titulo.text_shadow) this.tituloStyles['text-shadow'] = css.titulo.text_shadow;
				if (css.titulo.font_family) this.tituloStyles['font-family'] = css.titulo.font_family;
			}

			// • Sub-título (aplica a ambas descripciones)
			if (css.sub_titulo) {
				const st: { [k: string]: string } = {};
				if (css.sub_titulo.font_size?.[bp]) st['font-size'] = css.sub_titulo.font_size[bp];
				if (css.sub_titulo.line_height) st['line-height'] = css.sub_titulo.line_height;
				if (css.sub_titulo.text_shadow) st['text-shadow'] = css.sub_titulo.text_shadow;
				if (css.sub_titulo.font_weight) st['font-weight'] = css.sub_titulo.font_weight;
				if (css.sub_titulo.font_family) st['font-family'] = css.sub_titulo.font_family;
				this.subTituloStyles = { ...st };
				this.subTitulo2Styles = { ...st };
			}

			// • Imagen de recurso
			if (css.recurso_imagen) {
				const ri = css.recurso_imagen;
				if (ri.width?.[bp]) this.recursoImagenStyles['width'] = ri.width[bp];
				if (ri.height) this.recursoImagenStyles['height'] = ri.height;
				if (ri.margin_top) this.recursoImagenStyles['margin-top'] = ri.margin_top;
				if (ri.border_radius) this.recursoImagenStyles['border-radius'] = ri.border_radius;
				// Aplicar color de fondo si está activo
				if (ri.background_active && ri.background_color) {
					this.recursoImagenStyles['background-color'] = ri.background_color;
					// Añadir padding cuando el fondo está activo
					this.recursoImagenStyles['padding'] = '1.0rem';
					// Usar border_radius del JSON si existe; si no, aplicar valor por defecto
					if (!ri.border_radius) this.recursoImagenStyles['border-radius'] = '0.5rem';
				} else if (ri.background_active === false) {
					this.recursoImagenStyles['background-color'] = 'transparent';
				}
				// Si visible === false, ocultar la imagen de apoyo
				if (ri.visible === false) this.recursoUrl = '';
			}
		}
	}

	filterCountryCode(e: any): void {
		this.filteredCountriesCodes = [];
		let query = e.query;
		for (let i = 0; i < this.countriesCodes.length; i++) {
			let code = this.countriesCodes[i];
			if (code.dialCode.toLowerCase().indexOf(query.toLowerCase()) == 0) {
				this.filteredCountriesCodes.push(code);
			}
		}
	}

	filterCountry(e: any): void {
		this.filteredCountries = [];
		let query = e.query;
		for (let i = 0; i < this.countries.length; i++) {
			let country = this.countries[i];
			if (country.pais.toLowerCase().indexOf(query.toLowerCase()) == 0) {
				this.filteredCountries.push(country);
			}
		}
	}

	filterCity(e: any): void {
		this.filteredCities = [];
		let query = e.query;
		for (let i = 0; i < this.cities.length; i++) {
			let city = this.cities[i];
			if (city.estado.toLowerCase().indexOf(query.toLowerCase()) == 0) {
				this.filteredCities.push(city);
			}
		}
	}

	onSelectCountryCode(e: any) {
		if (e) {
			this.data.attributes.phone_mobile_iso_c = e.iso2.toUpperCase();
		}
	}

	onSelectCountry(e: any) {
		this.cities = [];
		if (e.value) {
			this.data.attributes.primary_address_country = e.value.abr_pais;
			this.data.attributes.primary_address_state = '00';
			this.formGroup.controls['ciudad'].enable();
			this.cities = e.value.estados;
		}
	}

	onSelectCity(e: any) {
		if (e.value) {
			this.data.attributes.primary_address_state = e.value.abr_estado;
		}
	}

	validar(): boolean {
		return !(this.formGroup.controls['ciudad'].value || this.cities.length == 0);
	}

	cleanFormData() {
		this.formBuilder = new FormBuilder();
		this.formGroup = this.formBuilder.group({
			nombres: new FormControl('', Validators.required),
			ap_pat: new FormControl('', [Validators.required]),
			ap_mat: ['', []],
			codigo: new FormControl('', Validators.required),
			phone: new FormControl('', [Validators.required]),
			email: new FormControl('', [Validators.email]),
			pais: new FormControl('', [Validators.required]),
			ciudad: new FormControl('', [Validators.required]),
		});
		this.data = {
			type: 'Leads',
			attributes: {
				name: '',
				account_name: '',
				first_name: '',
				last_name: '',
				last_name2_c: '',
				email1: '',
				phone_mobile: '',
				phone_mobile_iso_c: 'BO',
				fecha_validez_c: '',
				tipo_prospecto_c: 'NORMAL',
				etapa_c: 'CAPTADO',
				lead_source: 'LANDING_PAGE',
				lead_source2_c: 'FACEBOOK',
				lead_source_description: '',
				primary_address_country: 'BO',
				primary_address_state: '00',
				assigned_user_id: '',
				created_by: '',
			},
		};
		this.phoneInputComponent.writeValue({ phoneNumber: '', dialCode: '591', countryCode: 'BO' });
		this.formGroup.controls['phone'].setValue({ phoneNumber: '', dialCode: '591', countryCode: 'BO' });
		if (this.selectCountry) {
			this.formGroup.controls['pais'].setValue(this.selectCountry);
			this.cities = this.selectCountry.estados;
			this.formGroup.controls['ciudad'].enable();
		}
	}

	fillDataLead() {
		// Definir el mapeo
		const redesSociales: { [key: string]: string } = {
			'fb': 'FACEBOOK',
			'ig': 'INSTAGRAM',
			'tt': 'TIKTOK',
			'ws': 'WHATSAPP'
		};
		// Determinar el origen basado en 'rs'
		const sourceFromRS = this.rs ? (redesSociales[this.rs.toLowerCase()] || this.rs.toUpperCase()) : 'RS-NO-DEFINIDA';

		this.data = {
			type: 'Leads',
			attributes: {
				name: '',
				account_name: '',
				first_name: '',
				last_name: '',
				last_name2_c: '',
				email1: '',
				phone_mobile: '',
				phone_mobile_iso_c: 'BO',
				fecha_validez_c: '',
				tipo_prospecto_c: 'NORMAL',
				etapa_c: 'CAPTADO',
				lead_source: 'LANDING_PAGE',
				lead_source2_c: sourceFromRS,
				lead_source_description: this.nom_c,
				primary_address_country: 'BO',
				primary_address_state: '00',
				assigned_user_id: '',
				created_by: '',
			},
		};
		this.data.attributes.first_name = this.formGroup.controls['nombres'].value;
		this.data.attributes.last_name = this.formGroup.controls['ap_pat'].value;
		this.data.attributes.last_name2_c = this.formGroup.controls['ap_mat'].value;
		this.data.attributes.email1 = this.formGroup.controls['email'].value;
		this.data.attributes.phone_mobile = this.formGroup.controls['phone'].value.phoneNumber;
		this.data.attributes.phone_mobile_iso_c = this.formGroup.controls['phone'].value.countryCode;
		this.data.attributes.primary_address_country = this.formGroup.controls['pais'].value?.abr_pais;
		this.data.attributes.primary_address_state = this.formGroup.controls['ciudad'].value?.abr_estado;
	}

	async onClickSend(): Promise<void> {
		this.spinnerService.show();
		try {
			this.labelBoton = 'Asignando ejecutivo. ¡Espere por favor!';
			let x = await firstValueFrom(this._serv.obtenerVendedor(this.formGroup.controls['ciudad']?.value?.estado, this.data));
			this.fillDataLead();
			this.data.attributes.assigned_user_id = x.id;
			this.data.attributes.created_by = x.id;
			let token = await firstValueFrom(this._serv.getToken());
			const response = await firstValueFrom(this._serv.crearLead(this.data, token.access_token));
			if (response) {
				const nameComplete = this.formGroup.controls['nombres'].value + ' ' + this.formGroup.controls['ap_pat'].value + ' ' + this.formGroup.controls['ap_mat'].value;

				// Construir URL de WhatsApp y abrir ANTES del diálogo
				// para que el navegador lo considere resultado directo del clic del usuario
				let message = this.empresaConfig.titulo + ", Deseo información sobre '" + this.nom_c + "'. Mi nombre es: @@nombre_completo y mi ciudad de residencia es: @@ciudad";
				message = message.replace('@@nombre_completo', nameComplete);
				message = message.replace('@@ciudad', this.formGroup.controls['ciudad']?.value?.estado + ', ' + this.formGroup.controls['pais']?.value?.pais);
				const url = 'https://api.whatsapp.com/send?phone=' + x.telefono + '&text=' + encodeURIComponent(message);

				// Abrir WhatsApp inmediatamente (dentro del contexto del user gesture)
				window.open(url, '_blank');

				// Registrar conversión en gtag (no bloquea la navegación)
				const empresaConfig = environment.empresas.find((value) => { return value.sociedad == this.sociedad });
				this.gtagService.event('conversion', { send_to: empresaConfig?.googleTagManagerId + '/xWojCN699ekZEMb9sL8-', });

				// Mostrar diálogo de éxito; al cerrarse solo limpia el formulario
				this.dialogService.openDialog(true, nameComplete, () => {
					this.disableOption = false;
					this.cleanFormData();
					this.spinnerService.hide();
					this.labelBoton = 'Ejecutivo asignado';
				});
			} else {
				this.spinnerService.hide();
				this.dialogService.openDialog(false, 'Comuníquese con el administrador.', () => { });
			}
		} catch (error) {
			this.spinnerService.hide();
			this.labelBoton = 'CONTACTO WHATSAPP';
			console.log(error);
			Swal.fire({
				width: '300px',
				title: 'ERROR',
				text: 'Problemas con el servicio. Intentelo mas tarde.',
				allowOutsideClick: false,
				confirmButtonColor: this.secondaryColor,
				confirmButtonText: 'Aceptar',
			});
		}
	}

	getEmpresa(): any {
		return environment.empresas.find((value) => { return value.sociedad == this.sociedad });
	}

	/**
	 * simulator methods
	 */

	getData() {
		this.api100.requestData().subscribe({
			next: (values) => {
				this.superficies = values[0];
				console.log('surfaces: ', JSON.stringify(this.superficies));
				this.categorias = values[1];
				console.log('categories: ', JSON.stringify(this.categorias));
			},
			error: (e) => {
				console.log(e);
			}
		});
	}

	parseNumber(number: any) {
		return Number(number).toLocaleString("es-BO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}

	onChangeSuperficie(event: any) {
		//console.log(event)
		if (event.value) {
			this.loading = true;
			setTimeout(() => {
				this.loading = false;
				this.calcular(event.value);
			}, 300);
		} else {
			this.limpiar();
		}
	}

	limpiar() {
		this.cuota_inicial_minima = "";
		this.precio_contado = "";
		this.cuota_mes_desde = "";
	}

	calcular(superficie: any) {
		let categoria = this.categorias.find((cat: any) => cat.categoria == superficie.categoriaLote);
		if (categoria) {
			let precioLoteTotal = Number(categoria.precioM2) * Number(superficie.superficie);
			let precioContado = this.parseNumber(precioLoteTotal * (1 - (Number(categoria.descuentoContado) / 100)));
			this.precio_contado = this.parseNumber(precioLoteTotal);
			this.cuota_inicial_minima = this.parseNumber(categoria.cuotaInicialMinimo);
			this.cuota_mes_desde = this.parseNumber((precioLoteTotal - Number(categoria.cuotaInicialMinimo)) / Number(categoria.plazoMaximo));
		} else {
			this.limpiar();
			this.selectSuperficie = null;
			alert("Error de datos");
		}
	}

}
